module.exports = __webpack_public_path__ + "static/img/index-map.e0bcf9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-map.png
// module id = AiGT
// module chunks = 1